<!--  

CARD APRESENTADO NO PIPELINE

-->


<script>

// import CrmFunilNovo from './crm-pessoa-novo-form'
import { SysVars } from '../main';
import CrmCardDetalhe from './crm-card-detalhe'
import AgendaForm from '../forms/agenda-form'

export default {

    props: {
      negocio: Object,
    },

    data () {
        return {
            metadata: this.$store.getters.getEntities.metadata,
            codnegocio_detalhePopover: null,
            negocio_detalhePopover: null,

            showFormAgenda: false,
            codagenda: null,
            negociocrm: null,

            crud: '',
        }
    },

    components: {
        CrmCardDetalhe, AgendaForm
    },

    computed: {
        organizacao: function () {
            if (this.negociocrm && this.negociocrm.organizacao.length > 0)
              return this.negociocrm.organizacao[0]
            else 
              return null
        },

        pessoa: function () {
            if (this.negociocrm && this.negociocrm.pessoa.length > 0)
              return this.negociocrm.pessoa[0]
            else 
              return null
        },

        paramsAgenda: function () {
            return { negocio: this.negociocrm, organizacao: this.organizacao, pessoa: this.pessoa }        
        },
    },

    watch: {

    },

    filters: {

    },

    methods: {
        isAberto (st) {
            return st == 'A'
        },
        isGanho (st) {
            return st == 'G'
        },
        isPerdido (st) {
            return st == 'P'
        },


        handleEditNegocio (codnegocio) {
            this.$emit('edit', codnegocio)
        },

        // handleAdicionarAgenda (negocio) {
        //     this.$emit('adicionarAgenda', negocio)
        // },

        // handleEditAgenda (negocio, codagenda) {
        //     this.$emit('editAgenda', negocio, codagenda)
        // },

        closeDetalhePopover () {
            this.codnegocio_detalhePopover = null
        },

        showDetalhePopover (negocio) {
            this.codnegocio_detalhePopover = negocio.codnegocio
            this.negocio_detalhePopover = negocio
        },

        handleAdicionarAgenda (negocio) {
            //abre a tela de edicao
            this.negociocrm = negocio
            this.crud = SysVars.crudI 
            this.codagenda = null
            this.showFormAgenda = true;
        },

        handleEditAgenda (negocio, codagenda) {
            //abre a tela de edicao
            this.negociocrm = negocio
            this.crud = SysVars.crudU //operacao de edicao
            this.codagenda = codagenda
            this.showFormAgenda = true; //exibe o form de agenda
        },

        closeAgenda (agenda) {
            this.showFormAgenda = false
            if (agenda) {
                if (!this.negocio_detalhePopover.count_agenda) 
                   this.negocio_detalhePopover.count_agenda = 1
                else
                   this.negocio_detalhePopover.count_agenda = this.negocio_detalhePopover.count_agenda + 1
            }
        },

    },

    created () {
    }

}

</script>

<template>

    <div class="card-negocio" :class="{ 'card-perdido': isPerdido(negocio.stnegocio) }">
        <div class="row" :ref="'testeclose' + negocio.codnegocio">
            <span class="tag mr-2" v-if="negocio.tag_descricao" :style="'background-color: ' + negocio.tag_cor" :title="negocio.tag_descricao" data-toggle="tooltip" data-placement="top">  </span>
            <div class="col-12">
                    <span class="card-title w-100" @click="handleEditNegocio(negocio.codnegocio)"> {{ negocio.titulo }} </span>
            </div>
            <div class="col-9">
                <div class="row col">
                    <span class="card-text" v-if="!negocio.org_nome"><i class="fa fa-user pr-2" aria-hidden="true"></i> {{ negocio.pessoa_nome }} </span>
                    <span class="card-text" v-else>{{ negocio.org_nome }} </span>
                </div>
                <div class="row col">
                    <span class="card-value" v-if="negocio.valor > 0"> {{ negocio.valor | formatValue(2) }} </span>
                </div>
            </div>
            <!-- ICONES  DO CARD -->
            <div class="col-3 text-center" v-if="isAberto(negocio.stnegocio)">
                <span class="icon icon-atrasado" v-if="negocio.dias_atraso" :title="'Atividade atrasada há ' + negocio.dias_atraso + ' dias'" data-toggle="tooltip" data-placement="top" @click="showDetalhePopover(negocio)"><i class="fa fa-bookmark" aria-hidden="true"></i></span>
                <span class="icon icon-sem-agenda" v-if="negocio.count_agenda == 0" data-toggle="tooltip" data-placement="top" title="Nenhuma atividade. Crie uma atividade para este negócio."><i class="fa fa-warning" aria-hidden="true" @click="showDetalhePopover(negocio)"></i></span>
                <span class="icon icon-agenda" v-if="negocio.count_agenda > 0 && !negocio.dias_atraso" ><i class="fa fa-bookmark" aria-hidden="true" @click="showDetalhePopover(negocio)"></i></span>
            </div>
        </div>
        <div class="w-100">
            <span class="card-text"> {{ negocio.data | formatDataExtenso(true) }} </span>
            <span class="estagnado" v-if="negocio.stnegocio == 'A' && negocio.dias_estagnado" :title="'Negócio estagnado há ' + negocio.dias_estagnado + ' dias'" data-toggle="tooltip" data-placement="top"> {{ negocio.dias_estagnado}} D </span>
            <span class="icon icon-outros" v-if="negocio.count_anexo>0"><i class="fa fa-paperclip" aria-hidden="true"></i></span>
            <span class="icon icon-outros" v-if="negocio.count_note>0"><i class="fa fa-comment" aria-hidden="true"></i></span>
            <span class="icon icon-email" v-if="negocio.count_email>0"><i class="fa fa-envelope" aria-hidden="true"></i></span>
            <span class="ganho" title="Negócio ganho" data-toggle="tooltip" data-placement="top" v-if="isGanho(negocio.stnegocio)">GANHO</span>
            <span class="perdido" title="Negócio perdido" data-toggle="tooltip" data-placement="top" v-if="isPerdido(negocio.stnegocio)">PERDIDO</span>
        </div>
        <div v-if="codnegocio_detalhePopover == negocio.codnegocio" v-closable="{ exclude: ['testeclose' + negocio.codnegocio], handler: 'closeDetalhePopover' }">
            <crm-card-detalhe :index="codnegocio_detalhePopover" @adicionarAgenda="handleAdicionarAgenda" @editAgenda="handleAdicionarAgenda"></crm-card-detalhe>
        </div>

        <agenda-form v-if="showFormAgenda" :index="codagenda" :crud="crud" :params="paramsAgenda" @closeform="closeAgenda"></agenda-form>
    </div>

</template>


<style>


</style>



// WEBPACK FOOTER //
// src/forms-crm/crm-card.vue